import { requestWithToken as request } from "./api";

export function getResultStateByPeriod(period, initDate, endDate) {
    console.log("API CALL: getResultStateByPeriod", { period, initDate, endDate });
    return request.get(
        `/financial_reports_view/get_result_state_by_period/?period=${period}&init_date=${initDate}&end_date=${endDate}`
    );
}

/**
 * Obtiene el acumulado mensual de ventas desagregado por cuenta level_3.
 * @param {string} initDate - Fecha inicio en formato YYYY-MM-DD
 * @param {string} endDate  - Fecha fin en formato YYYY-MM-DD
 * @param {string} groupBy  - Columna para agrupar ('cuentas', 'clientes' o nombre de categoría)
 */
export function getSalesByLevel3(initDate, endDate, groupBy = 'cuentas') {
    return request.get(
        `/financial_reports_view/get_sales_by_level3/?init_date=${initDate}&end_date=${endDate}&group_by=${groupBy}`
    );
}

/**
 * Obtiene las 3 tarjetas de resumen de ventas (mes actual, YTD, LTM)
 * con MoM y YoY ya calculados en el backend, cubriendo períodos
 * comparables que pueden estar fuera del rango filtrado en la tabla.
 * @param {string} endDate - Fecha de referencia (último mes) en formato YYYY-MM-DD
 */
export function getSalesSummaryCards(endDate) {
    return request.get(
        `/financial_reports_view/get_sales_summary_cards/?end_date=${endDate}`
    );
}

/**
 * Obtiene el acumulado mensual de gastos desagregado por nivel 2 y nivel 3.
 * @param {string} initDate - Fecha inicio en formato YYYY-MM-DD
 * @param {string} endDate  - Fecha fin en formato YYYY-MM-DD
 * @param {string} groupBy  - Columna para agrupar ('cuentas', 'clientes' o nombre de categoría)
 */
export function getExpensesByLevels(initDate, endDate, groupBy = 'cuentas') {
    return request.get(
        `/financial_reports_view/get_expenses_by_levels/?init_date=${initDate}&end_date=${endDate}&group_by=${groupBy}`
    );
}

/**
 * Obtiene las 3 tarjetas de resumen de gastos (mes actual, YTD, LTM)
 * con MoM y YoY ya calculados en el backend.
 * @param {string} endDate - Fecha de referencia (último mes) en formato YYYY-MM-DD
 */
export function getExpensesSummaryCards(endDate) {
    return request.get(
        `/financial_reports_view/get_expenses_summary_cards/?end_date=${endDate}`
    );
}

// export function saveCartera(
//     company_id,
//     old_analists,
//     new_analists,
//     deleted_analists
// ) {
//     const param = {
//         old_analists: old_analists,
//         new_analists: new_analists,
//         deleted_analists: deleted_analists,
//     };
//     return request.post(`/analyst_view/${company_id}/save_cartera/`, param);
// }
